/*
    © 2021 EcomGraduates
*/

// Sort by
document.querySelector('#sort-by')?.addEventListener('change', (e) => {
    window.location.href = window.location.href.split('?')[0] + `?sort_by=${e.target.value}`
})

// Init Ajaxinate (infinite scrolling)
const initAjaxinate = () => {
    if (document.querySelector('#AjaxinatePagination')) {
        // eslint-disable-next-line no-unused-vars
        const endlessScroll = new Ajaxinate({
            pagination: '#AjaxinatePagination',
            container: '#AjaxinateContainer',
            method: 'click',
            loadingText: 'Loading...'
        })
    }
}
initAjaxinate()

// Collection filters - handle filtering
const collectionFiltersHandleFiltering = () => {
    const filters = document.querySelectorAll('.collection-filters-input')

    filters.forEach((filter) => {
        filter.addEventListener('change', () => {
            const tags = []

            filters.forEach((el) => {
                if (el.checked && el.dataset.tag) {
                    tags.push(el.dataset.tag)
                }
            })

            const params = new URLSearchParams(window.location.search)
            params.delete('page')

            if (tags.length) {
                params.set('constraint', encodeURI(tags.join('+')))
            } else {
                params.delete('constraint')
            }

            const url = `${window.location.pathname}?${params}`
            window.history.replaceState({}, '', url)

            const oldProductList = document.querySelector('#main .product-list')
            if (oldProductList) {
                oldProductList.style.opacity = 0.25
            }

            setTimeout(() => {
                const offcanvas = document.querySelector('#offcanvas-filters')
                bootstrap.Offcanvas.getInstance(offcanvas)?.hide()
            }, 200)

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser()
                    const newDocument = parser.parseFromString(data, 'text/html')
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'))

                    window.scrollTo(0, 0)
                    initAjaxinate()
                })
        })
    })
}
collectionFiltersHandleFiltering()

// Collection filters - Sticky sidebar (desktop)
// const collectionFiltersSticky = () => {
//     const el = document.querySelector('#filters-sticky-top')
//     if (el) {
//         const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight
//         el.style.top = `${navbarHeight + 24}px`
//         el.style.height = `calc(100vh - ${navbarHeight + 24 + 20}px`
//         el.style.zIndex = 1019
//         el.style.overflowY = 'auto'
//     }
// }
// collectionFiltersSticky()

// Collection filters - Build offcanvas
const collectionFiltersAppendOffcanvas = () => {
    const offcanvas = document.querySelector('#offcanvas-filters')

    offcanvas?.addEventListener('show.bs.offcanvas', () => {
        const filters = document.querySelector('#collection-filters')
        offcanvas.querySelector('.offcanvas-body').append(filters)
    })
}
collectionFiltersAppendOffcanvas()
